import React, {useEffect, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import {useSelector, useDispatch} from "react-redux";
import ConfirmationModal from './ConfirmationModal.js';
import APICom from '../../utils/helpers/APICom.js';
import {store, persistor} from '../../store.js';
import PersistStorage from "../../utils/helpers/PersistStorage";


const CallerIDNotifierListener = (props) => {
    const dispatch = useDispatch();
    const [calleridIframeURL, setCalleridIframeURL] = useState("");
    const {AffiliateData, GlobalASCSData, ASCSSettingData} = useSelector((store) => store.combinedata);
    const [showiFrame, setshowiFrame] = useState(false);
    const {loginData} = useSelector((store) => store.login);
    const [selectedAffiliateID, setSelectedAffiliateID] = useState();
    const [calleridIframeSrc, setCalleridIframeSrc] = useState("");
    const [calleridIframeTitle, setCalleridIframeTitle] = useState("");


    const handleIframeLoad = () => {
        const iframe = document.getElementById('calleridservercommcls');
        // console.log(loginData);
        iframe.contentWindow.postMessage(loginData.vExtension, "*");
    };
    const setupEventListeners = () => {
        try {
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
            window.addEventListener(messageEvent, CallerIDNotifierListener_Identifer);
        } catch (ee) {
            console.log('CallerIDNotifierListener Setup Error: ' + ee);
        }
    };


    useEffect(() => {
        let URL = ''
        if (GlobalASCSData !== null && GlobalASCSData !== undefined && GlobalASCSData.length > 0) {
            const jsonArray = GlobalASCSData;
            URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            URL = URL.value.replace('/api', '');
            setCalleridIframeURL(URL);
        } else
            setCalleridIframeURL('google.com');
        setupEventListeners();
        try {
            if (loginData != null && loginData != undefined) {
                setCalleridIframeSrc(URL + "/asterisk/asteriskCom")
                setCalleridIframeTitle("Caller-ID Notification is turned ON")
                handleIframeLoad();
            }
        } catch (r) {
        }

    }, []);


    const CallerIDNotifierListener_Identifer = (e) => {
        // for AsteriskMessage calling events
        try {
            if (e.data.indexOf("AsteriskMessage=") > -1) {
                var eData = "";
                eData = e.data;
                eData = e.data.substring(16);
                ClientEvent(eData, -1);
            }
        } catch {
        }
    }
    const handleIframeClose = () => {
        setshowiFrame(false);
    };

    const ClientEvent = (message, TenantID) => {
        // calling function on events message from signal R
        var value = JSON.parse(message);
        switch (value[1].EVENT) {
            case "CALLCONNECTED":
                if (value[3].CALLERID != "") {
                    LoadCallerID(value[3].CALLERID, value[5].AffiliateID );
                }
                break;
        }
    }

    const FormatPhoneNumber = (value) => {
        var result = "";
        let tmp1, tmp2, tmp3 = ''
        result = value;
        tmp1 = result.substring(0, 3);
        tmp2 = result.substring(3, 6);
        tmp3 = result.substring(6, 10);
        result = "+1" + tmp1 + tmp2 + tmp3
        return result;
    }

    const LoadCallerID = (callerid, affiliate_id) => {
        //function to populate caller id on parent component
        try {
            var caller_id = FormatPhoneNumber(callerid);
                props.onUpdatePhone(caller_id, affiliate_id);
        } catch (err) {
        }
    }



    return (
        <div style={{display: 'none'}}>
            <iframe
                src={calleridIframeURL + '/asterisk/asteriskCom'}
                id='calleridservercommcls'
                className="calleridservercommcls"
                onLoad={handleIframeLoad}
                title={calleridIframeTitle}
                style={{
                    overflow: 'auto',
                    position: 'fixed',
                    top: '145px',
                    left: '50px',
                    height: '600px',
                    width: '80%',
                    zIndex: '7777',
                    border: '1px solid black'
                }}
            />
            <Button onClick={handleIframeClose} variant="dark" style={{
                overflow: 'auto',
                position: 'fixed',
                top: '745px',
                left: '50px',
                width: '10%',
                zIndex: '7777'
            }}>Close</Button>
        </div>
    );
};

export default CallerIDNotifierListener;
